import { render, staticRenderFns } from "./Organizer.vue?vue&type=template&id=3661999b&scoped=true&"
import script from "./Organizer.vue?vue&type=script&lang=js&"
export * from "./Organizer.vue?vue&type=script&lang=js&"
import style0 from "./Organizer.vue?vue&type=style&index=0&id=3661999b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3661999b",
  null
  
)

export default component.exports